import React from "react";

export function Input({ className = "", ...props }) {
  return (
    <input
      className={`w-full px-4 py-3 border border-secondary-200 rounded-xl bg-secondary-50 text-secondary-900 placeholder-secondary-400 focus:outline-none focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 transition-all ${className}`}
      {...props}
    />
  );
}
